import { FormikProps, useFormik } from "formik";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAccount, useConnect } from "wagmi";

import { useIsMobile } from "@/hooks/use-mobile";
import { connectWalletRetx } from "@/lib/utils";
import { accountSelector } from "@/store/account/account.slice";
import { wallets } from "@/wagmi/wallets";

import { If } from "../custom/condition";
import { InputPasswordField } from "../share/input";
import { Button } from "../ui/button";

const localWallet = "metaDap";
function ConnectWalletModal({ onCancel }: { onCancel?: () => void }) {
  const { account } = useSelector(accountSelector);
  const { isMobile } = useIsMobile(1180);
  const { address } = useAccount();
  const { connect, connectors } = useConnect({
    onSuccess() {
      onCancel && onCancel();
    },
  });
  const { isRetxWallet } = account;

  const [deepConnect, setDeepConnect] = useState(null);
  const [showEnterPassword, setEnterShowPassword] = useState(false);

  const listConnectors = connectors?.filter(
    (connector) => connector?.id !== localWallet
  );

  const formik = useFormik({
    initialValues: { key: "" },
    onSubmit: async (values, { setErrors, resetForm, setSubmitting }) => {
      const { key } = values;
      try {
        if (!key) {
          throw new Error();
        } else {
          setSubmitting(true);
          // TODO: call api get private key
          await connectWalletRetx({ password: key });
          onCancel();
          resetForm();
        }
      } catch (e) {
        setErrors({
          key: "Mật khẩu không đúng",
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    setDeepConnect(null);
  }, []);

  return (
    <div className="xl:bg-backgroundConnectWallet bg-right-bottom bg-no-repeat">
      <If
        condition={!isMobile}
        /* connect wallet desktop */
        Then={
          <div className="grid grid-cols-1 xl:grid-cols-5 xl:gap-2 xl:bg-backgroundConnectWalletLeft bg-left-bottom bg-no-repeat p-6">
            <div className="xl:col-span-2 border-b xl:border-b-[0px] pb-3 xl:border-r border-[#F4F4F6] xl:pr-3">
              <If
                condition={!address}
                Then={
                  <div className="flex justify-around xl:justify-center xl:grid xl:grid-cols-1 xl:gap-4 mr-2 w-full overflow-x-auto no-scrollbar">
                    {/* button connect */}
                    <If
                      condition={!isRetxWallet}
                      Then={listConnectors?.map((connector, i) => {
                        return (
                          <button
                            key={connector?.id}
                            className="flex items-center justify-between py-2 px-1 xl:p-3 bg-gray-50 hover:bg-gray-200 rounded-lg transition-all ease-linear duration-300"
                            onClick={() => {
                              connect({ connector });
                              !wallets?.[i]?.installed
                                ? setDeepConnect(wallets?.[i])
                                : setDeepConnect(null);
                            }}
                          >
                            <div className="flex flex-col xl:flex-row items-center w-auto">
                              <Image
                                alt=""
                                width="33"
                                height="33"
                                src={wallets?.[i]?.logoUrl}
                              />
                              <div className="xl:ml-2">
                                <span className="text-xs xl:text-base xl:font-bold text-[#0B0A0F]">
                                  {connector?.name}
                                </span>
                              </div>
                            </div>
                            {i === 0 && (
                              <div>
                                <p className="hidden xl:block border border-main px-[6px] py-[2px] rounded font-semibold text-main bg-[#ff880019] text-xs">
                                  Phổ biến
                                </p>
                              </div>
                            )}
                          </button>
                        );
                      })}
                      Else={
                        <button
                          className="flex items-center justify-between py-2 px-1 xl:p-3 bg-gray-50 hover:bg-gray-200 rounded-lg transition-all ease-linear duration-300"
                          onClick={() => {
                            setEnterShowPassword(true);
                          }}
                        >
                          <div className="flex flex-col xl:flex-row items-center w-auto">
                            <Image
                              alt=""
                              width="33"
                              height="33"
                              src="/icons/wallets/metaDap.svg"
                            />
                            <div className="xl:ml-2">
                              <span className="text-xs xl:text-base xl:font-bold text-[#0B0A0F]">
                                MetaDAP Wallet
                              </span>
                            </div>
                          </div>
                          <div>
                            <span className="hidden xl:block border border-main px-[6px] py-[2px] rounded font-semibold text-main bg-[#ff880019] text-xs">
                              Đề xuất
                            </span>
                          </div>
                        </button>
                      }
                    />
                  </div>
                }
              />
            </div>
            <div className="col-span-3 py-4 xl:py-6 md:px-[30px] lg:px-[60px]">
              <If
                condition={isRetxWallet}
                Then={
                  <If
                    condition={showEnterPassword}
                    Then={<RetxConnectForm formik={formik} />}
                    Else={<WhatIsWalletComponent />}
                  />
                }
                Else={
                  <If
                    condition={deepConnect}
                    Then={
                      <div className="flex flex-col justify-between items-center text-center">
                        <img
                          className="w-[67px] mb-3 xl:mb-6"
                          src={deepConnect?.logoUrl}
                          alt=""
                        />
                        <h4 className="text-purple_700 text-xl font-bold xl:mb-2">
                          {deepConnect?.title} chưa được cài đặt
                        </h4>
                        <div className="my-4 mb-6 xl:mb-10">
                          <p className="text-lg">
                            Vui lòng cài đặt {deepConnect?.title} Extension để
                            kết nối tới ví {deepConnect?.title}.
                          </p>
                        </div>
                        <div className="mb-4">
                          {deepConnect?.downloadLink && (
                            <Button
                              type="button"
                              className="h-10 md:h-12 md:w-[200px] px-8 py-4 z-10"
                              onClick={() =>
                                window.open(deepConnect?.downloadLink, "_blank")
                              }
                            >
                              <span className="typography-h5">Cài đặt</span>
                            </Button>
                          )}
                        </div>
                        <span
                          onClick={() => {
                            if (deepConnect?.id === "metaMask") {
                              window.open(
                                "https://support.metamask.io/hc/en-us/articles/360015489531-Getting-started-with-MetaMask",
                                "_blank"
                              );
                            } else {
                              window.open(
                                "https://www.coinbase.com/wallet/articles/getting-started-extension",
                                "_blank"
                              );
                            }
                          }}
                          className="text-primary font-bold mb-4 xl:mb-10 z-10 cursor-pointer text-base"
                        >
                          "Hướng dẫn cài đặt"
                        </span>
                      </div>
                    }
                    Else={<WhatIsWalletComponent />}
                  />
                }
              />
            </div>
          </div>
        }
        /* connect wallet mobile */
        Else={
          <div>
            <If
              condition={isRetxWallet}
              Then={<RetxConnectForm formik={formik} />}
              Else={listConnectors?.map((connector, i) => {
                const walletDefault = wallets?.filter(
                  (wallet) => wallet?.isMobile
                )?.[0];
                if (connector?.id === walletDefault?.id)
                  return (
                    <div
                      key={i}
                      className="flex flex-col justify-center items-center text-center"
                    >
                      <img
                        className="w-[56px] mb-4"
                        src="/icons/wallets/metamaskWallet.svg"
                        alt=""
                      />
                      <p className="text-sm font-semibold  mb-4 text-[blue]">
                        Có phải bạn đang sử dụng trên thiết bị di động?
                      </p>
                      <div className="flex flex-col items-center mb-6">
                        <div
                          className="mb-4 text-sm"
                          dangerouslySetInnerHTML={{
                            __html:
                              '<p>Vui lòng cài đặt và mở ứng dụng trên trình duyệt <span style="color: #FF8800">Metamask</span> để có thể kết nối và sử dụng ví mã hóa!</p>',
                          }}
                        />
                        <Button
                          onClick={() => {
                            connect({ connector });
                            if (
                              walletDefault.deepLink &&
                              walletDefault.installed === false
                            ) {
                              window.open(walletDefault.deepLink);
                            }
                          }}
                          className="h-10 md:h-12 w-full md:w-[160px]"
                        >
                          <span className="typography-h5">Tiếp tục</span>
                        </Button>
                      </div>
                    </div>
                  );
              })}
            />
          </div>
        }
      />
    </div>
  );
}

export default ConnectWalletModal;

export function WhatIsWalletComponent() {
  return (
    <>
      <div className="col-span-3">
        <h4 className="typography-h3 text-center font-bold text-purple_700 mb-4 xl:mb-10">
          Ví là gì?
        </h4>
        <div className="">
          <div className="grid grid-cols-5 gap-3 mb-5 xl:mb-10">
            <div className="col-span-1">
              <Image
                className="mt-3"
                alt=""
                width="60"
                height="60"
                src={`/img/connect-wallet/wagmi_home.svg`}
              />
            </div>
            <div className="col-span-4">
              <b className="text-sm xl:text-lg mb-2">
                Nơi lưu trữ tài sản số hoá của bạn
              </b>
              <p className="text-xs text-[#4D5461] text-justify mt-1">
                Ví dùng để gửi, nhận, lưu trữ và hiển thị các tài sản mã hóa như
                Chứng chỉ đầu tư (Certificates) hoặc Chứng chỉ sở hữu
                (Certificates).
              </p>
            </div>
          </div>
          <div className="grid grid-cols-5 gap-3 mb-5 xl:mb-10">
            <div className="col-span-1">
              <Image
                className="mt-3"
                alt=""
                width="60"
                height="60"
                src={`/img/connect-wallet/wagmi_lock.svg`}
              />
            </div>
            <div className="col-span-4">
              <b className="text-sm xl:text-lg mb-2">
                Cách thức mới để Đăng nhập
              </b>
              <p className="text-xs text-[#4D5461] text-justify mt-1">
                Thay vì phải tạo tài khoản mới và mật khẩu để đăng nhập trên mọi
                website, bạn chỉ cần kết nối ví điện tử của bạn.
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center xl:mb-6">
          <Button
            variant="outline"
            className="px-6 z-10 h-10 md:h-12"
            type="button"
            onClick={() =>
              window.open(
                "https://support.risegate.io/bat-dau/xac-thuc-vi",
                "_blank"
              )
            }
          >
            <span className="typography-h5">Tìm hiểu thêm</span>
          </Button>
        </div>
        <div className="hidden xl:flex justify-center items-center text-[#FCB121]">
          <img
            className="w-6 h-6"
            src="/img/connect-wallet/circle_exclamation.svg"
            alt=""
          />
          <span className="text-xs">
            Mỗi tài khoản chỉ được liên kết tới 1 địa chỉ ví duy nhất.
          </span>
        </div>
      </div>
    </>
  );
}

interface Props {
  formik: FormikProps<{ key: string }>;
}

export function RetxConnectForm(props: Props) {
  const { formik } = props;

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col justify-center items-center gap-4 xl:gap-6"
    >
      <div className="relative">
        <Image width="74" height="74" src="/icons/wallets/metaDap.svg" alt="" />
      </div>
      <h3
        className="text-xs text-gray_500 xl:text-2xl xl:text-purple_700 xl:font-bold text-center [&>span]:font-bold"
        dangerouslySetInnerHTML={{
          __html:
            "Vui lòng nhập mật khẩu đăng nhập để truy cập <span>Ví MetaDAP</span>",
        }}
      />
      <div className="w-full xl:my-6">
        <InputPasswordField
          formik={formik}
          label="Mật khẩu"
          name="key"
          labelClass="text-sm text-purple_700 font-medium"
          className="h-12 py-3 pl-4 pr-4 mt-2 text-base rounded-md"
          layoutClass="input-focus input-hover"
          placeholder="Nhập mật khẩu"
          messageError={formik.touched?.["key"] && formik.errors?.["key"]}
        />
      </div>
      <div className="mb-3 w-full md:w-auto">
        <Button
          disabled={formik.isSubmitting}
          type="submit"
          className="w-full md:min-w-[140px] h-12 bg-main"
        >
          {formik.isSubmitting ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
              Đang kết nối...
            </>
          ) : (
            <p className="typography-h5">Kết nối ví</p>
          )}
        </Button>
      </div>
    </form>
  );
}
